import {buildVueLazyParcel} from "../../spa/base-build-vue-parcel";

import MailToFaxApp from "./App.vue";
import {buildRouter} from "./router";

export const parcelVue = buildVueLazyParcel(buildRouter, MailToFaxApp);
